import { render, staticRenderFns } from "./startseite-1.vue?vue&type=template&id=8f38b592"
import script from "./startseite-1.vue?vue&type=script&lang=js"
export * from "./startseite-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports